import { Box } from "@mui/system";
import React from "react";
import BarChart from "./BarChart";

export const Checkbox = React.memo(({ klausimas, atsakymai }) => {
  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <BarChart klausimas={klausimas} atsakymai={atsakymai} />
    </Box>
  );
});
